import { z } from 'zod';

export const customerInformationSchema = z.object({
  contentHtml: z
    .string()
    .min(1, 'Содержимое не может быть пустым')
    .max(200_000, 'Содержимое слишком большое (max 200000 символов)')
});

export type CustomerInformationFormData = z.infer<
  typeof customerInformationSchema
>;
